import { store }  from '@/store/index.js'
import navistarSpecification from '@/assets/json/navistarSpecification_20221005T123000Z.json'
import { vehicleGetFpcFamiliesAll,vehicleGetFpcFamiliesNoTest,
          engineGetFpcFamiliesAll, 
          vehicleFpcFamilyExecutionsByFamilyIdsAll, vehicleGetFpcFamilyExecutionsByFamilyIdsNoTest,
          engineFpcFamilyExecutionsByFamilyIdsAll, 
        } from '@/services/importingJsons.js'
const groupBy = (arr, criteria) =>{
  const newObj = arr.reduce((acc, currentValue) => {
    if (!acc[currentValue[criteria]]) {
      acc[currentValue[criteria]] = []
    }
    acc[currentValue[criteria]].push(currentValue)
    return acc
  }, {})
  return newObj
}
const familySelection = {
  namespaced: true,
  state: () => ({
    families: {
      selected: [],
      vehicleOptions: [],
      engineOptions: [],
      loading: false,
      error: false
    },
    familyExecutions: {
      selected: [],
      options: [],
      loadingIds: [],
      error: false
    },
    cscCodes: {
      selected: []
    }
  }),
  mutations: {
    // Families
    selectedFamilies (state, value) {
      state.families.selected = value
    },
    familyVehicleOptions (state, value) {
      state.families.vehicleOptions = value
    },
    familyEngineOptions (state, value) {
      state.families.engineOptions = value
    },
    familiesLoading (state, value) {
      state.families.loading = value
    },
    familiesLoadingError (state, value) {
      state.families.error = value
    },
    // FamilyExecutions
    selectedFamilyExecutions (state, value) {
      state.familyExecutions.selected = value
    },
    familyExecutionOptions (state, value) {
      state.familyExecutions.options = value
    },
    familyExecutionIdsLoading (state, value) {
      state.familyExecutions.loadingIds = value
    },
    familyExecutionsLoadingError (state, value) {
      state.familyExecutions.error = value
    },
    selectedCscCodes (state, value) {
      state.cscCodes.selected = value
    },
    // Common
    resetSelected (state) {
      state.families.selected = []
      state.familyExecutions.selected = []
      state.familyExecutions.options = []
      state.cscCodes.selected = []
    },
    reset (state) {
      state.families = {
        selected: [],
        vehicleOptions: [],
        engineOptions: [],
        loading: [],
        error: false
      }
      state.familyExecutions = {
        selected: [],
        options: [],
        loadingIds: [],
        error: false
      }
      state.cscCodes = {
        selected: []
      }
    }
  },
  getters: {
    getFamiliesOptions: (state, getters, rootState, rootGetters) => {
      var result =  (rootGetters['population/getProductType'] === 'VEHICLE'
        ? state.families.vehicleOptions : state.families.engineOptions)
        .map(x => {
          if(state.families.vehicleOptions[0]?.Family.length < 5 || state.families.engineOptions[0]?.Family.length < 5)
            return {
              id:  '0' + x.Family,
              label: '0' + x.FpcExecutionDescGUI
            }
          else {
            return {
              id: x.Family,
              label: x.FpcExecutionDescGUI
            }
          }
        })
      if ((rootGetters['population/getProductType']?.name === 'NAVISTAR')){
        result = navistarSpecification.FeatureGroups.map(x => {
          return {
            id: x.FeatureGroup,
            label: x.FeatureGroup + ' ' + x.Description.replaceAll(/\S*/g, word => `${word.slice(0, 1)}${word.slice(1).toLowerCase()}`)
          }
        })
      }
      else if ((rootGetters['population/getProductType']?.name === 'MAN')){
          result = []
      }
      return result
    },
    isFamilyExecutionsLoading: (state) => {
      return state.familyExecutions.loadingIds.length > 0
    },
    isSelected: (state) => {
      return state.families.selected.length > 0 || state.familyExecutions.selected.length > 0
    },
    getFamilyExecutionsReportFormatted: (state) => {
      return state.familyExecutions.selected.map(x => ({ id: x }))
    },
    getCscCodesReportFormatted: (state) => {
      return state.cscCodes.selected?.map(x => ({ id: x }))
    },
    getAllSelections: (state) => {
      return {
        families: state.families.selected,
        familyExecutions: state.familyExecutions.selected,
        cscCodes: state.cscCodes.selected
      }
    }

  },
  actions: {
    loadStateFromFile ({ commit }, data) {
      commit('selectedFamilies', data.families)
      commit('selectedFamilyExecutions', data.familyExecutions)
      commit('selectedCscCodes', data.cscCodes)
    },
    setSelectedFamilies ({ dispatch, commit, state, getters }, value) {
      const selected = state.families.selected
      if (selected.length < value.length) {
        if(value[0] === 0 && selected.length === 0){
          //IF we implement a select all in the variant family
          // const families = getters.getFamiliesOptions
          // dispatch('addExecutionsByFamily', families)
        }
        else{
          const difference = value.filter(x => !selected.includes(x))
          const family = getters.getFamiliesOptions.find(x => x.id === difference[0])
          dispatch('addExecutionsByFamily', family)
        }
      } 
      else {
        // When the treeselect is deselected
        commit('familyExecutionOptions',
          state.familyExecutions.options
            .filter(x => value.includes(x.id))
        )
        commit('selectedFamilyExecutions',
          state.familyExecutions.selected
            .filter(x => value.includes(x.split(':')[0]))
        )
      }
      commit('selectedFamilies', value)
    },
    getFamilies ({ commit, state, rootState, dispatch }) {
      const productType = rootState.population.productType
      if (!productType) return

      commit('familiesLoadingError', false)
      const dataLoaded =
        (productType === 'VEHICLE' && state.families.vehicleOptions.length > 0) ||
        (productType === 'ENGINES' && state.families.engineOptions.length > 0)
      if (dataLoaded) return

      const featureFunction = () => { 
        if(productType === 'VEHICLE'){
          if(store.state.isODP_unlimited)return  vehicleGetFpcFamiliesAll()
          else return vehicleGetFpcFamiliesNoTest()
        }
        if(productType === 'ENGINES')return  engineGetFpcFamiliesAll()
        if(productType?.name === 'NAVISTAR') return  engineGetFpcFamiliesAll()
      }  
      featureFunction()?.then(result => {
        commit('familiesLoading', true)
        if (productType === 'VEHICLE') {
          commit('familyVehicleOptions', result)
        }
        if (productType === 'ENGINES') {
          commit('familyEngineOptions', result)
        }
        
        const families = state.families

        if (families.selected.length > 0) {
          dispatch('addExecutionsByFamily', families.selected)
        }
      }).catch(error => {
        console.error('getFpcFamilies: ', error)
        commit('familiesLoadingError', true)
      }).finally(() => {
        commit('familiesLoading', false)
      })
    },
    addExecutionsByFamily ({ commit, state, dispatch, rootGetters, getters }, families) {
      if (typeof families === 'object' && !Array.isArray(families)) {
        families = [families.id]
      }
      const productType = rootGetters['population/getProductType']
      commit('familyExecutionsLoadingError', false)
      commit('familyExecutionIdsLoading', [...state.familyExecutions.loadingIds, ...families])

      if(productType === 'VEHICLE' || productType === 'ENGINES' ){
        const featureFunction = () =>{ 
          if(productType === 'VEHICLE'){
            if(store.state.isODP_unlimited)return  vehicleFpcFamilyExecutionsByFamilyIdsAll()
            else return vehicleGetFpcFamilyExecutionsByFamilyIdsNoTest()
          }
          if(productType === 'ENGINES')return  engineFpcFamilyExecutionsByFamilyIdsAll()
  
        }
        featureFunction().then(result => {
          //Removing whitespaces to ensure selection options match
          const trimId = obj => {
            obj.id && (obj.id = obj.id.trim())
            obj.children && obj.children.forEach(trimId)
            return obj
          }
          const updatedData = result.map(trimId)
          
          //Appending variables types based on ecu list 
          var mappingVariantFamilyDescriptions = []
          state.families.selected.forEach((fpc) => 
            mappingVariantFamilyDescriptions.push(...updatedData.filter(object => object.id === fpc)
          ))

          if(productType?.name === 'NAVISTAR')mappingVariantFamilyDescriptions = state.families.selected
          commit('familyExecutionOptions', mappingVariantFamilyDescriptions)
        }).catch(error => {
          console.error('getFpcFamilyExecutionsByFamilyId: ', error)
          commit('familyExecutionsLoadingError', true)
          families.forEach(function (entry) {
            dispatch('removeIdFromFamilySelection', entry)
          })
        }).finally(() => {
          families.forEach(function (entry) {
            commit('familyExecutionIdsLoading',
              state.familyExecutions.loadingIds
                .filter(id => id !== entry)
            )
          })
        })
      }
      //Loading navistar variant family executions
      else if(productType?.name === 'NAVISTAR'){

        var result = []
        //Selected family loop that map json Nvaistar specifications
        families.forEach( (family ,index) => {
          result = [...result, ...navistarSpecification.FeatureGroups.filter(function (item) { 
            return (String(JSON.stringify(item.FeatureGroup))).toLowerCase() === (String(JSON.stringify(families[index]).toLowerCase()))
          })]

        })
        //Map featuregroup based on the selected families
        const resultsgroup = groupBy(result, 'FeatureGroup')
        Object.keys(resultsgroup).forEach(function (key) {
          const family = getters.getFamiliesOptions.find(x => x.id === (key))
          commit('familyExecutionOptions', [...state.familyExecutions.options, {
            id: key,
            label: family ? family.label : key,
            children: resultsgroup[key]["0"].FeatureCodes.map(child => ({
              id: `${key}:${child.FeatureCode}`,
              label:  child.FeatureCode + ' -' + child.Description.replaceAll(/\S*/g, word => `${word.slice(0, 1)}${word.slice(1).toLowerCase()}`)
            }))
          }])
        })

      }
    },
    removeIdFromFamilySelection ({ commit, state }, id) {
      commit('selectedFamilies', state.families.selected.filter(x => x !== id))
    }
  }
}
export default familySelection
